import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Divider, notification, Input, DatePicker } from "antd";
import dayjs from "dayjs";
import ticketsActions from "../../redux/ticket/actions";
import schedulesActions from "../../redux/schedules/actions";
import pasteIcon from "../../images/paste.png";
import {
  bulgarianLocalCalandarText,
  bulgarianLocaleDaysAndMonths,
  epochToNormalDate,
  dateStringToEpoch,
  convertToEuro,
} from "../../utils/utility";
import ConfirmEmailAndPhoneModal from "./ConfirmEmailAndPhoneModal";
import RefundSchedulesModal from "./RefundSchedulesModal";
import { t } from "i18next";

const CancelReservationPage = () => {
  const dispatch = useDispatch();
  const [selectedBox, setSelectedBox] = useState(null);

  const { getSingleTicketInfo } = ticketsActions;
  const { getRefundTicketSchedules } = schedulesActions;
  const { companies, token, companiesDetails, showEuroPrice } = useSelector(
    (state) => state.mainReducer
  );
  const { singleTicketInfo } = useSelector((state) => state.ticketReducer);

  const [ticketNumber, setTickeNumber] = useState("");

  const [refundSchedulesDate, setRefundSchedulesDate] = useState(dayjs());
  const [showSelectNewDate, setShowSelectNewDate] = useState(false);
  const [showSchedulesModal, setShowSchedulesModal] = useState(false);
  const [newPlaceNumber, setNewPlaceNumber] = useState(null);
  const [newForDate, setNewForDate] = useState(null);
  const [newKursId, setNewKursId] = useState(null);
  const [newPriceId, setNewPriceId] = useState(null);

  useEffect(() => {
    if (singleTicketInfo.length > 0) {
      setNewPlaceNumber(singleTicketInfo[0]?.place);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleTicketInfo]);

  const getFreeRefundTicketSchedules = (from, to, date) => {
    setShowSchedulesModal(true);
    dispatch(
      getRefundTicketSchedules(
        token,
        companies[0]?.id,
        from,
        to,
        dateStringToEpoch(date.format("DD/MM/YYYY HH:mm"))
      )
    );
  };

  const getSingleTicketAndOpenModal = () => {
    setShowSelectNewDate(false);
    if (ticketNumber.length > 0) {
      dispatch(getSingleTicketInfo(token, companies[0]?.id, ticketNumber));
    } else {
      notification.error({
        message: t("pleaseFillTicketNumber"),
        placement: "top",
      });
    }
  };

  const getDestinationDate = (date, dateString) => {
    setRefundSchedulesDate(date);
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setTickeNumber(text);
    } catch (err) {
      console.error("Failed to read clipboard contents: ", err);
    }
  };

  return (
    <>
      <ConfirmEmailAndPhoneModal setShowSelectNewDate={setShowSelectNewDate} />
      <RefundSchedulesModal
        setNewPlaceNumber={setNewPlaceNumber}
        newPlaceNumber={newPlaceNumber}
        newForDate={newForDate}
        newKursId={newKursId}
        newPriceId={newPriceId}
        setShowSchedulesModal={setShowSchedulesModal}
        setSelectedBox={setSelectedBox}
        setNewForDate={setNewForDate}
        setNewKursId={setNewKursId}
        setNewPriceId={setNewPriceId}
        showSchedulesModal={showSchedulesModal}
        selectedBox={selectedBox}
      />

      <div className="refund-ticket-form-item-container">
        <div className="refund-ticket-form-container">
          <div>
            <div className="refund-ticket-settings-items-container">
              <h1 className="refund-ticket-settings-heading">
                {t("ticketRevalidation")}
              </h1>
            </div>
            <Divider />
            <div className="refund-ticket-items-container">
              <div className="refund-ticket-input-item">
                <Input
                  value={ticketNumber}
                  style={{ height: "50px" }}
                  onChange={(e) => setTickeNumber(e.target.value)}
                  placeholder={t("ticketNumber")}
                  suffix={
                    <Button
                      type="text"
                      icon={
                        <img alt={t("paste")} src={pasteIcon} width="20px" />
                      }
                      onClick={handlePaste}
                      title={t("paste")}
                    />
                  }
                />
                <Button
                  style={{ width: "70%" }}
                  className="refund-ticket-button custom-button"
                  type="primary"
                  size="large"
                  onClick={getSingleTicketAndOpenModal}
                >
                  {t("foundTicket")}
                </Button>
              </div>
              {showSelectNewDate && (
                <>
                  {singleTicketInfo.map((ticket) => {
                    return (
                      <div
                        style={{ background: "#fff" }}
                        key={ticket.ticketNumber}
                        className="success-ticket-payment-ticket-container"
                      >
                        <div className="success-ticket-payment-ticket-item">
                          <img
                            alt="logo"
                            style={{ width: "80px", marginBottom: "10px" }}
                            src={`data:image/jpeg;base64,${companiesDetails?.logo}`}
                          />
                          <p style={{ color: "#b3b3b3" }}>Е-{t("ticket")}</p>
                        </div>

                        <div className="success-ticket-payment-ticket-item">
                          <span>{t("ticketNumber")}</span>
                          <span>{ticket.ticketNumber}</span>
                        </div>
                        <div className="success-ticket-payment-ticket-item">
                          <span>{t("destination")}</span>
                          <span>
                            {ticket.fromName} - {ticket.toName}
                          </span>
                        </div>
                        <div className="success-ticket-payment-ticket-item">
                          <span>{t("dateAndHour")}</span>
                          <span>{epochToNormalDate(ticket.startTime)}</span>
                        </div>
                        <div className="success-ticket-payment-ticket-item">
                          <span>{t("name")}</span>
                          <span>{ticket.forPerson}</span>
                        </div>
                        <div className="success-ticket-payment-ticket-item">
                          <span>{t("place")}</span>
                          <span>{ticket.place}</span>
                        </div>
                        <div className="success-ticket-payment-ticket-item">
                          <span>{t("price")}</span>
                          <div>
                            <span>
                              {ticket?.price?.toFixed(2)} €
                            </span>
                            {showEuroPrice && (
                              <>
                                <span> / </span>
                                <span>
                                  {convertToEuro(ticket?.price)?.toFixed(2)} {t("lv")}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                          <label
                            style={{
                              marginBottom: "5px",
                              fontSize: "14px",
                              color: "#000",
                              fontWeight: "bold",
                            }}
                          >
                            {t("chooseNewDate")}
                          </label>
                          <DatePicker
                            allowClear={false}
                            inputReadOnly={true}
                            minDate={dayjs()}
                            value={refundSchedulesDate}
                            showNow={false}
                            size="large"
                            style={{ width: "100%", marginTop: "5px" }}
                            format="DD/MM/YYYY"
                            onChange={getDestinationDate}
                            placeholder={t("date")}
                            locale={{
                              lang: bulgarianLocalCalandarText,
                              dayjsLocale: bulgarianLocaleDaysAndMonths,
                            }}
                          />
                        </div>

                        <Button
                          type="text"
                          style={{
                            width: "100%",
                            marginTop: "10px",
                            background: "#e6e6e6",
                          }}
                          onClick={() =>
                            getFreeRefundTicketSchedules(
                              singleTicketInfo[0]?.fromId,
                              singleTicketInfo[0]?.toId,
                              refundSchedulesDate
                            )
                          }
                          size="large"
                        >
                          {t("foundFreeSchedule")}
                        </Button>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="refund-ticket-column-image"></div>
      </div>
    </>
  );
};

export default CancelReservationPage;
